import { __assign, __extends } from "tslib";
import React from "react";
import { View, Text } from "react-native";
import PnmacComposer from "../Composer";
import PnmacSend from "../Send";
import PropTypes from "prop-types";
import styles from "./PnmacInputToolbar.styles.js";
var PnmacInputToolbar = /** @class */function (_super) {
  __extends(PnmacInputToolbar, _super);
  function PnmacInputToolbar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.renderSend = function () {
      if (_this.props.renderSend) {
        return _this.props.renderSend(_this.props);
      }
      return /*#__PURE__*/React.createElement(PnmacSend, __assign({}, _this.props));
    };
    _this.renderTextInputCounter = function () {
      if (_this.props.maxLength && _this.props.maxLength > 0) {
        return /*#__PURE__*/React.createElement(Text, {
          style: {
            color: "#737373",
            marginBottom: 20,
            marginRight: 10
          }
        }, _this.props.text ? _this.props.text.length : 0, "/(", _this.props.maxLength, ")");
      } else return null;
    };
    _this.renderComposer = function () {
      if (_this.props.renderComposer) {
        return _this.props.renderComposer(_this.props);
      }
      return /*#__PURE__*/React.createElement(PnmacComposer, __assign({
        _scrollToInput: _this.props._scrollToInput
      }, _this.props));
    };
    return _this;
  }
  PnmacInputToolbar.prototype.render = function () {
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.container, this.props.containerStyle],
      testID: "inputToolbar"
    }, /*#__PURE__*/React.createElement(View, {
      style: [styles.primary, this.props.primaryStyle]
    }, this.renderComposer(), this.props.chatBusyState == "isReady" ? /*#__PURE__*/React.createElement(View, null, this.renderSend(), this.renderTextInputCounter()) : /*#__PURE__*/React.createElement(View, null)));
  };
  return PnmacInputToolbar;
}(React.Component);
PnmacInputToolbar.defaultProps = {
  renderSend: null,
  renderComposer: null,
  containerStyle: {},
  primaryStyle: {},
  accessoryStyle: {}
};
PnmacInputToolbar.propTypes = {
  renderSend: PropTypes.func,
  renderComposer: PropTypes.func,
  containerStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  primaryStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  accessoryStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
};
export default PnmacInputToolbar;